/**
 * Resources Slider initialization
 */
document.addEventListener( 'DOMContentLoaded', function() {
	const slider = document.querySelector( '.resources-slider' );
	if ( ! slider ) {
		return;
	}
	
	var tnsSlider = tns( {
		container: '.resources-slider',
		items: 1.2,
		slideBy: '1',
		mouseDrag: true,
		loop: false,
		nav: false,
		responsive: {
			768: {
				items: 2.4,
			},
			1024: {
				items: 3,
			},
		},
	} );

	window.initTnsAccessibility( tnsSlider );
} ); 